module.exports = __webpack_public_path__ + "img/fleetifyLogo.53fe0eac.png";